export const getHeader = (title: string | undefined): string => {
  return title ? title : '';
};
